import { FunctionComponent, useContext } from "react";
import { ReactReduxContext } from "react-redux";

import { useIsFeatureActive } from "@/utils/useIsFeatureActive";
import { FeaturesCodes } from "@/pages/Private/pages/Users/enum/codes";

import { HelpLauncherButton } from "./HelpLauncherButton";
import { useHasHeaderLauncher } from "./helpLauncherRegistry";

const PinnedHelpLauncherButton: FunctionComponent = () => {
	const isActive = useIsFeatureActive(FeaturesCodes.HELP_CENTER);
	const hasHeaderLauncher = useHasHeaderLauncher();

	// The page's own header already shows the icon — one per screen is the whole point.
	if (!isActive || hasHeaderLauncher) {
		return null;
	}

	return (
		// `top-2` centres the 32px button in the 48px header row every other page uses, and `right-4`
		// matches those headers' `px-4`, so the icon lands in the same place with or without a header.
		<div className="fixed right-4 top-2 z-[100] flex items-center">
			<HelpLauncherButton />
		</div>
	);
};

/**
 * The help launcher for pages that have no header bar to hang it on — the dashboard, the tracker
 * pages, the onboarding and subscription flows, the small admin screens. Same icon, same corner as
 * the header-mounted `HelpLauncher`; it simply stands down whenever a header on screen renders one.
 */
export const PinnedHelpLauncher: FunctionComponent = () => {
	const reduxContext = useContext(ReactReduxContext);

	if (!reduxContext) {
		return null;
	}

	return <PinnedHelpLauncherButton />;
};
